import { ComprehensiveDiagnosisSection } from "@/features/landing/ui/comprehensive-diagnosis-section";
import { HeroSection } from "@/features/landing/ui/hero-section";
import { LandingHeaderDesktop } from "@/features/landing/ui/landing-header-desktop";
import { LandingHeaderMobile } from "@/features/landing/ui/landing-header-mobile";
import { QuestionsSection } from "@/features/landing/ui/questions-section";
import { GradientSection } from "@/features/landing/ui/section-wrapper";
import { lazy, Suspense } from "react";

// ✅ Good - Content is server-rendered, only JS loads lazily
const StepsSection = lazy(() =>
  import("./steps-section").then((mod) => ({ default: mod.StepsSection })),
);

const LandingFooter = lazy(() =>
  import("./landing-footer").then((mod) => ({ default: mod.LandingFooter })),
);

// ✅ Good - Interactive components can be client-only
const MobileMenu = lazy(() =>
  import("./mobile-menu").then((mod) => ({ default: mod.MobileMenu })),
);

const ContinueQuestionnaireModal = lazy(() =>
  import("./continue-questionnaire-modal").then((mod) => ({
    default: mod.ContinueQuestionnaireModal,
  })),
);

export function Landing() {
  // Theme color palette for seamless section transitions
  const HERO_THEME = {
    start: "#FFDDD3", // Soft pink
    end: "#E7D7F2", // Light blue
  };

  const SPEECH_THEME = {
    start: "#FEDEE1", // Soft pink
    end: "#FEEDE1", // Warm yellow
  };

  const STEP_ONE_THEME = {
    start: "#fbd8ee", // Gentle pink
    end: "#FFF2E9", // Light purple
  };

  return (
    <>
      <div className="fixed inset-0 -z-50 bg-gradient-to-b from-gradient-start to-gradient-end" />
      <div className="min-h-full">
        <LandingHeaderDesktop />

        <GradientSection
          topColor={HERO_THEME.start}
          bottomColor={HERO_THEME.end}
          stampsTop="100px"
          bottomWave={SPEECH_THEME.start}
          bottomWaveId={1}
        >
          <LandingHeaderMobile />
          <HeroSection />
          <div className="px-4 py-16 lg:hidden">
            <ComprehensiveDiagnosisSection />
          </div>
        </GradientSection>

        <GradientSection
          topColor={SPEECH_THEME.start}
          bottomColor={SPEECH_THEME.end}
        >
          <QuestionsSection />
        </GradientSection>

        <GradientSection
          topWave={SPEECH_THEME.end}
          topWaveId={2}
          topColor={STEP_ONE_THEME.start}
          bottomColor={STEP_ONE_THEME.end}
          stampsCount={false}
        >
          <Suspense
            fallback={<div className="h-96 animate-pulse bg-gray-100" />}
          >
            <StepsSection />
          </Suspense>
        </GradientSection>
        <Suspense fallback={<div className="h-32 animate-pulse bg-gray-100" />}>
          <LandingFooter />
        </Suspense>
        <Suspense fallback={null}>
          <MobileMenu />
        </Suspense>
      </div>

      <Suspense fallback={null}>
        <ContinueQuestionnaireModal />
      </Suspense>
    </>
  );
}
